import styled from 'styled-components';
import { MenuRightIcon, MenuDownIcon, QuestionIcon,  } from '../Icons';
import TextButton from '../TextButton';

export const ArrowExpanderStyle = {
	MenuRightIcon: styled(MenuRightIcon)`
        margin-right : 0.5rem;
    `,
	MenuDownIcon: styled(MenuDownIcon)`
        margin-right : 0.5rem;
    `,
};

export const HelpExpanderStyle = {
	QuestionIcon : styled(QuestionIcon)`
        margin-right : 0.5rem;
    `
};

export default {
	TextButton: styled(TextButton)`
        &:focus{
            outline : 0;
            border : none;
            background-color : transparent;
        }
        &:hover{
            background-color : transparent;
            border : none;
        }
    `,
	Container : styled.div`
        margin-top : 1rem;
    `
};